/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingDetailsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './MarketplaceListingDetailsRpc-app';
import * as Queries from './MarketplaceListingDetailsRpc-app.dfc.new';
import type { AdditionalContextArgs } from './MarketplaceListingDetailsRpc-app.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetListingDetailsV2QueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetListingDetailsV2ResponseType>,
    References.GetListingDetailsV2RequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getListingDetailsV2',
            References.GetListingDetailsV2ResponseType
          >
        : References.GetListingDetailsV2ResponseType)
    | undefined;
};

export function useGetListingDetailsV2Query<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetListingDetailsV2ResponseType>,
    References.GetListingDetailsV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingDetailsV2QueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LISTING_DETAILS_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingDetailsV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingDetailsV2QueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingDetailsV2QueryReturn<T>;
}

type UseGetListingDetailsV2LazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetListingDetailsV2ResponseType>,
    References.GetListingDetailsV2RequestType,
    T extends true
      ? Record<
          'getListingDetailsV2',
          References.GetListingDetailsV2ResponseType
        >
      : References.GetListingDetailsV2ResponseType
  >;

export function useGetListingDetailsV2LazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetListingDetailsV2ResponseType>,
    References.GetListingDetailsV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingDetailsV2LazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LISTING_DETAILS_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingDetailsV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetListingDetailsV2LazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetListingDetailsV2LazyQueryReturn<T>;
}

type UseGetListingDetailsV2SuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetListingDetailsV2ResponseType>,
    References.GetListingDetailsV2RequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getListingDetailsV2', References.GetListingDetailsV2ResponseType>
    : References.GetListingDetailsV2ResponseType;
};

export function useGetListingDetailsV2SuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetListingDetailsV2ResponseType>,
    References.GetListingDetailsV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingDetailsV2SuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LISTING_DETAILS_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getListingDetailsV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingDetailsV2SuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingDetailsV2SuspenseQueryReturn<T>;
}

type UseGetListingDetailsV3QueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetListingDetailsV3ResponseType>,
    References.GetListingDetailsV3RequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getListingDetailsV3',
            References.GetListingDetailsV3ResponseType
          >
        : References.GetListingDetailsV3ResponseType)
    | undefined;
};

export function useGetListingDetailsV3Query<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetListingDetailsV3ResponseType>,
    References.GetListingDetailsV3RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingDetailsV3QueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LISTING_DETAILS_V3_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingDetailsV3: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingDetailsV3QueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingDetailsV3QueryReturn<T>;
}

type UseGetListingDetailsV3LazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetListingDetailsV3ResponseType>,
    References.GetListingDetailsV3RequestType,
    T extends true
      ? Record<
          'getListingDetailsV3',
          References.GetListingDetailsV3ResponseType
        >
      : References.GetListingDetailsV3ResponseType
  >;

export function useGetListingDetailsV3LazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetListingDetailsV3ResponseType>,
    References.GetListingDetailsV3RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingDetailsV3LazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LISTING_DETAILS_V3_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingDetailsV3: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetListingDetailsV3LazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetListingDetailsV3LazyQueryReturn<T>;
}

type UseGetListingDetailsV3SuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetListingDetailsV3ResponseType>,
    References.GetListingDetailsV3RequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getListingDetailsV3', References.GetListingDetailsV3ResponseType>
    : References.GetListingDetailsV3ResponseType;
};

export function useGetListingDetailsV3SuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetListingDetailsV3ResponseType>,
    References.GetListingDetailsV3RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingDetailsV3SuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LISTING_DETAILS_V3_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getListingDetailsV3: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingDetailsV3SuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingDetailsV3SuspenseQueryReturn<T>;
}

type UseIsStandardizedInstallQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.IsStandardizedInstallResponseType>,
    References.IsStandardizedInstallRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'isStandardizedInstall',
            References.IsStandardizedInstallResponseType
          >
        : References.IsStandardizedInstallResponseType)
    | undefined;
};

export function useIsStandardizedInstallQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.IsStandardizedInstallResponseType>,
    References.IsStandardizedInstallRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseIsStandardizedInstallQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.IS_STANDARDIZED_INSTALL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            isStandardizedInstall: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseIsStandardizedInstallQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseIsStandardizedInstallQueryReturn<T>;
}

type UseIsStandardizedInstallLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.IsStandardizedInstallResponseType>,
    References.IsStandardizedInstallRequestType,
    T extends true
      ? Record<
          'isStandardizedInstall',
          References.IsStandardizedInstallResponseType
        >
      : References.IsStandardizedInstallResponseType
  >;

export function useIsStandardizedInstallLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.IsStandardizedInstallResponseType>,
    References.IsStandardizedInstallRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseIsStandardizedInstallLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.IS_STANDARDIZED_INSTALL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            isStandardizedInstall: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseIsStandardizedInstallLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseIsStandardizedInstallLazyQueryReturn<T>;
}

type UseIsStandardizedInstallSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.IsStandardizedInstallResponseType>,
    References.IsStandardizedInstallRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'isStandardizedInstall',
        References.IsStandardizedInstallResponseType
      >
    : References.IsStandardizedInstallResponseType;
};

export function useIsStandardizedInstallSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.IsStandardizedInstallResponseType>,
    References.IsStandardizedInstallRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseIsStandardizedInstallSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.IS_STANDARDIZED_INSTALL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            isStandardizedInstall: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseIsStandardizedInstallSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseIsStandardizedInstallSuspenseQueryReturn<T>;
}

type UseGetAppFeaturesBatchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppFeaturesBatchResponseType>,
    References.GetAppFeaturesBatchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAppFeaturesBatch',
            References.GetAppFeaturesBatchResponseType
          >
        : References.GetAppFeaturesBatchResponseType)
    | undefined;
};

export function useGetAppFeaturesBatchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppFeaturesBatchResponseType>,
    References.GetAppFeaturesBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppFeaturesBatchQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APP_FEATURES_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppFeaturesBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppFeaturesBatchQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppFeaturesBatchQueryReturn<T>;
}

type UseGetAppFeaturesBatchLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppFeaturesBatchResponseType>,
    References.GetAppFeaturesBatchRequestType,
    T extends true
      ? Record<
          'getAppFeaturesBatch',
          References.GetAppFeaturesBatchResponseType
        >
      : References.GetAppFeaturesBatchResponseType
  >;

export function useGetAppFeaturesBatchLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppFeaturesBatchResponseType>,
    References.GetAppFeaturesBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppFeaturesBatchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_FEATURES_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppFeaturesBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppFeaturesBatchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppFeaturesBatchLazyQueryReturn<T>;
}

type UseGetAppFeaturesBatchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAppFeaturesBatchResponseType>,
    References.GetAppFeaturesBatchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getAppFeaturesBatch', References.GetAppFeaturesBatchResponseType>
    : References.GetAppFeaturesBatchResponseType;
};

export function useGetAppFeaturesBatchSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppFeaturesBatchResponseType>,
    References.GetAppFeaturesBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppFeaturesBatchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APP_FEATURES_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppFeaturesBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppFeaturesBatchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppFeaturesBatchSuspenseQueryReturn<T>;
}

type UseGetListingSupplementQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetListingSupplementResponseType>,
    References.GetListingSupplementRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getListingSupplement',
            References.GetListingSupplementResponseType
          >
        : References.GetListingSupplementResponseType)
    | undefined;
};

export function useGetListingSupplementQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetListingSupplementResponseType>,
    References.GetListingSupplementRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSupplementQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LISTING_SUPPLEMENT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingSupplement: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingSupplementQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingSupplementQueryReturn<T>;
}

type UseGetListingSupplementLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetListingSupplementResponseType>,
    References.GetListingSupplementRequestType,
    T extends true
      ? Record<
          'getListingSupplement',
          References.GetListingSupplementResponseType
        >
      : References.GetListingSupplementResponseType
  >;

export function useGetListingSupplementLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetListingSupplementResponseType>,
    References.GetListingSupplementRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSupplementLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LISTING_SUPPLEMENT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingSupplement: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetListingSupplementLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetListingSupplementLazyQueryReturn<T>;
}

type UseGetListingSupplementSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetListingSupplementResponseType>,
    References.GetListingSupplementRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getListingSupplement',
        References.GetListingSupplementResponseType
      >
    : References.GetListingSupplementResponseType;
};

export function useGetListingSupplementSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetListingSupplementResponseType>,
    References.GetListingSupplementRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSupplementSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LISTING_SUPPLEMENT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getListingSupplement: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingSupplementSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingSupplementSuspenseQueryReturn<T>;
}

type UseGetListingSupplementBatchQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetListingSupplementBatchResponseType>,
    References.GetListingSupplementBatchRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getListingSupplementBatch',
            References.GetListingSupplementBatchResponseType
          >
        : References.GetListingSupplementBatchResponseType)
    | undefined;
};

export function useGetListingSupplementBatchQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetListingSupplementBatchResponseType>,
    References.GetListingSupplementBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSupplementBatchQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LISTING_SUPPLEMENT_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingSupplementBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingSupplementBatchQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingSupplementBatchQueryReturn<T>;
}

type UseGetListingSupplementBatchLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetListingSupplementBatchResponseType>,
    References.GetListingSupplementBatchRequestType,
    T extends true
      ? Record<
          'getListingSupplementBatch',
          References.GetListingSupplementBatchResponseType
        >
      : References.GetListingSupplementBatchResponseType
  >;

export function useGetListingSupplementBatchLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetListingSupplementBatchResponseType>,
    References.GetListingSupplementBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSupplementBatchLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LISTING_SUPPLEMENT_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getListingSupplementBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetListingSupplementBatchLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetListingSupplementBatchLazyQueryReturn<T>;
}

type UseGetListingSupplementBatchSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetListingSupplementBatchResponseType>,
    References.GetListingSupplementBatchRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getListingSupplementBatch',
        References.GetListingSupplementBatchResponseType
      >
    : References.GetListingSupplementBatchResponseType;
};

export function useGetListingSupplementBatchSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetListingSupplementBatchResponseType>,
    References.GetListingSupplementBatchRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetListingSupplementBatchSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LISTING_SUPPLEMENT_BATCH_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getListingSupplementBatch: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetListingSupplementBatchSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetListingSupplementBatchSuspenseQueryReturn<T>;
}

type UseGetAppReleaseHistoryQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppReleaseHistoryResponseType>,
    References.GetAppReleaseHistoryRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAppReleaseHistory',
            References.GetAppReleaseHistoryResponseType
          >
        : References.GetAppReleaseHistoryResponseType)
    | undefined;
};

export function useGetAppReleaseHistoryQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppReleaseHistoryResponseType>,
    References.GetAppReleaseHistoryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppReleaseHistoryQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APP_RELEASE_HISTORY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppReleaseHistory: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppReleaseHistoryQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppReleaseHistoryQueryReturn<T>;
}

type UseGetAppReleaseHistoryLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppReleaseHistoryResponseType>,
    References.GetAppReleaseHistoryRequestType,
    T extends true
      ? Record<
          'getAppReleaseHistory',
          References.GetAppReleaseHistoryResponseType
        >
      : References.GetAppReleaseHistoryResponseType
  >;

export function useGetAppReleaseHistoryLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppReleaseHistoryResponseType>,
    References.GetAppReleaseHistoryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppReleaseHistoryLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_RELEASE_HISTORY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppReleaseHistory: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppReleaseHistoryLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppReleaseHistoryLazyQueryReturn<T>;
}

type UseGetAppReleaseHistorySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAppReleaseHistoryResponseType>,
    References.GetAppReleaseHistoryRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAppReleaseHistory',
        References.GetAppReleaseHistoryResponseType
      >
    : References.GetAppReleaseHistoryResponseType;
};

export function useGetAppReleaseHistorySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppReleaseHistoryResponseType>,
    References.GetAppReleaseHistoryRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppReleaseHistorySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APP_RELEASE_HISTORY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppReleaseHistory: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppReleaseHistorySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppReleaseHistorySuspenseQueryReturn<T>;
}
